import { DiscussionEmbed } from 'disqus-react'
import { useEffect } from 'react'

import { useTheme } from '@/components/ThemeProvider/ThemeProvider'

type Props = {
  identifier: string
  slug: string
  title: string
}

const Disqus = ({ identifier, slug, title }: Props) => {
  const theme = useTheme()

  useEffect(() => {}, [theme])

  // Don't render Disqus on non-article pages or outside of the production environment
  //
  // When Disqus renders, it associates the current URL with the identifier (post ID)
  // Unfortunately the URL seems to be read *not* from props, but from the browser, opening us up to wrong URLs
  //
  // https://help.disqus.com/en/articles/1717138-why-are-the-same-comments-showing-up-on-multiple-pages
  if (
    typeof window === 'undefined' ||
    window.location.hostname !== 'edhrec.com' ||
    !/^\/articles\/[^/]+$/.test(window.location.pathname) // Check for /articles/[slug]
  ) {
    return null
  }

  return (
    <DiscussionEmbed
      config={{
        identifier,
        language: 'en',
        title,
        url: `https://edhrec.com/articles/${slug}`,
      }}
      shortname='edhrec'
    />
  )
}

export default Disqus
